import { useReducer } from 'react'
import type { AuthFlowAction, AuthFlowState, AuthMode } from './AuthFlow.types'

const createInitialState = (mode: AuthMode): AuthFlowState => ({
  mode,
  botProtectionEnabled: false,
  botProtectionProviderId: null,
  botProtectionClientConfig: null,
  twoFactorChallenge: null,
  twoFactorCode: '',
  twoFactorTouched: false,
  twoFactorSubmitting: false,
  twoFactorError: '',
})

const authFlowReducer = (state: AuthFlowState, action: AuthFlowAction): AuthFlowState => {
  switch (action.type) {
    case 'SYNC_MODE': {
      return {
        ...state,
        mode: action.mode,
      }
    }
    case 'BOT_PROTECTION_CONFIG_RESOLVED': {
      return {
        ...state,
        botProtectionEnabled: action.enabled,
        botProtectionProviderId: action.providerId,
        botProtectionClientConfig: action.clientConfig,
      }
    }
    case 'SET_TWO_FACTOR_CHALLENGE': {
      return {
        ...state,
        twoFactorChallenge: action.challenge,
        twoFactorCode: '',
        twoFactorTouched: false,
        twoFactorSubmitting: false,
        twoFactorError: '',
      }
    }
    case 'CLEAR_TWO_FACTOR': {
      return {
        ...state,
        twoFactorChallenge: null,
        twoFactorCode: '',
        twoFactorTouched: false,
        twoFactorSubmitting: false,
        twoFactorError: '',
      }
    }
    case 'SET_TWO_FACTOR_CODE': {
      return {
        ...state,
        twoFactorCode: action.value,
      }
    }
    case 'SET_TWO_FACTOR_TOUCHED': {
      return {
        ...state,
        twoFactorTouched: action.value,
      }
    }
    case 'SET_TWO_FACTOR_SUBMITTING': {
      return {
        ...state,
        twoFactorSubmitting: action.value,
      }
    }
    case 'SET_TWO_FACTOR_ERROR': {
      return {
        ...state,
        twoFactorError: action.value,
      }
    }
    default:
      return state
  }
}

export const useAuthFlowReducer = (mode: AuthMode) => useReducer(authFlowReducer, createInitialState(mode))
